import Vue from 'vue';
import apiService from "../api.mjs";
import template from './talk-to-expert.html';
import FormErrors from './../components/form-errors';
import FormErrorList from './../components/form-error-list';
import { formErrorComputed, formErrorData, formErrorMethods } from '../helpers';
import {
    DialogBox,
    dialogDefaultComputed,
    dialogDefaultConfiguration,
    dialogDefaultData,
    dialogDefaultMethods,
} from "./dialog-box.mjs";

const tagName = 'dialog-talk-to-expert';

export const talkToExpertDialogDefinition = {
    ...dialogDefaultConfiguration,
    template : template,
    components : {
        'form-errors'     : FormErrors,
        'form-error-list' : FormErrorList
    },
    computed : {
        ...dialogDefaultComputed,
        ...formErrorComputed,
    },
    data() {
        return {
            ...dialogDefaultData,
            ...formErrorData
        };
    },
    methods  : {
        ...dialogDefaultMethods,
        ...formErrorMethods,
        onNameEnterKey : function( event ) {
            this.switchFocus( event, 'email_input', this.model.customer_name.length > 5 );
        },
        onEmailEnterKey : function( event ) {
            this.switchFocus( event, 'phone_input', this.model.email_address.length > 5 );
        },
        onPhoneEnterKey : function( event ) {
            this.switchFocus( event, 'message_input', this.model.phone_number.length > 7 );
        },
        onSendMessageClick : function( event ) {
            event.preventDefault();
            this.model.onSendMessageClick();
        },
        switchFocus : function( event, key, test ) {
            event.preventDefault();
            if( test && key in this.$refs )
                this.$refs[ key ].focus();
        }
    }
};

Vue.component( tagName, talkToExpertDialogDefinition );

export class TalkToExpertDialog extends DialogBox {

    constructor() {
        super();

        // Data fields
        this.name    = '';
        this.email   = '';
        this.phone   = '';
        this.enquiry = '';

        // Request processing
        this.req_active = false;
        this.sent       = false;
    }

    getComponentTag() {
        return tagName;
    }

    getComponentData() {
        return {
            req_active    : this.req_active,
            sent          : this.sent
        };
    }

    onSendMessageClick() {
        if( this.req_active )
            return false;

        this.req_active = true;

        // Function exists on Vue component above.
        // noinspection JSUnresolvedFunction
        this.component.clearAllErrors();

        apiService.talkToAnExpert( this.name, this.email, this.phone, this.enquiry )
            .then( response => { console.info('response', response);
                if( ! response.sent ) {
                    let errors = response.errors || { 'general' : [
                        'Something went wrong, and the request could not be completed.'
                    ]};

                    // noinspection JSUnresolvedFunction
                    this.component.mapErrors( errors );
                    return;
                }

                this.sent = true
            })
            .catch( error => console.warn('error', error) )
            .finally( () => {
                this.req_active = false
            })
        ;
    }

}
